exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/galeri-standard-template/galeri-standard-template.component.css
// module id = ../../../../../src/app/galeri-standard-template/galeri-standard-template.component.css
// module chunks = main